import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MISSION_TYPE_PRESCRIPTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { CompetencesElementaires } from 'src/app/shared/enums/competence.enum';
import {
	Slot,
	SlotStatus
} from 'src/app/shared/models/services-aide-emploi/slot';

@Component({
	selector: 'app-dashboard-prescriber-appointments',
	templateUrl: './dashboard-prescriber-appointments.component.html',
	styleUrls: ['./dashboard-prescriber-appointments.component.scss']
})
export class DashboardPrescriberAppointmentsComponent implements OnInit {
	listAppointments: Slot[] = [];
	manyNewAppointments: boolean = false;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.loadNewAppointments();
	}

	formatTime(minutes: number): string {
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours}:${mins.toString().padStart(2, '0')}`;
	}

	loadNewAppointments() {
		this.facade.prescriberService
			.loadNewBookedAppointmentsByStatus(SlotStatus[SlotStatus.INITIAL])
			.subscribe({
				next: (appointments) => {
					this.listAppointments = appointments;
					this.manyNewAppointments = this.listAppointments.length > 1;
				},
				error: (e) => {}
			});
	}

	navigateToAddForm(appointment: Slot) {
		this.router.navigate(['/gestion/formations/add'], {
			queryParams: {
				date: new Date(appointment.date).toISOString(), // formate la date en 'YYYY-MM-DD'
				startTime: appointment.startTime,
				endTime: appointment.endTime,
				missionType: MISSION_TYPE_PRESCRIPTION,
				skill: CompetencesElementaires.PRESCRIPTION.name,
				id: appointment.id
			}
		});
	}
}
